
// Power Go Object fetching URI and QueryString
var oPgsUrl = {
  sRequestUri   : '',
  sQueryString  : '',
  oQueryParams  : {},

  // Parse URL and keep in memory the URI and QueryString
  init: function(){

    oPgsUrl.sRequestUri = location.pathname;
    oPgsUrl.sQueryString = location.search.substr(1);

    var tmp = [];
    oPgsUrl.sQueryString
      .split("&")
      .forEach(function (item) {
        if( ! item )
        {
          return;
        }
        tmp = item.split("=");
        oPgsUrl.oQueryParams[tmp[0]] = decodeURIComponent(tmp[1]);
      });

    delete tmp;
  },

  // Return the value for a QueryString key param
  getQueryValue: function(sQueryKey){
    var sReturn = null;

    if( oPgsUrl.oQueryParams[sQueryKey] ) {
      sReturn = oPgsUrl.oQueryParams[sQueryKey];
    }

    return sReturn;
  },

};
